import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "card mb-5 mb-xl-10"
}
const _hoisted_2 = { class: "card-header border-0" }
const _hoisted_3 = { class: "card-title m-0" }
const _hoisted_4 = { class: "fw-bolder m-0" }
const _hoisted_5 = { class: "collapse show" }
const _hoisted_6 = { class: "card-body border-top p-9" }
const _hoisted_7 = { class: "row mb-6" }
const _hoisted_8 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_9 = { class: "col-lg-8 fv-row" }
const _hoisted_10 = { class: "fv-plugins-message-container" }
const _hoisted_11 = { class: "fv-help-block" }
const _hoisted_12 = { class: "row mb-6" }
const _hoisted_13 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_14 = { class: "col-lg-8 fv-row" }
const _hoisted_15 = { value: "" }
const _hoisted_16 = /*#__PURE__*/_createElementVNode("option", { value: "5" }, "5", -1)
const _hoisted_17 = /*#__PURE__*/_createElementVNode("option", { value: "10" }, "10", -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("option", { value: "20" }, "20", -1)
const _hoisted_19 = { class: "fv-plugins-message-container" }
const _hoisted_20 = { class: "fv-help-block" }
const _hoisted_21 = { class: "row mb-6" }
const _hoisted_22 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_23 = { class: "col-lg-8 fv-row" }
const _hoisted_24 = { value: "" }
const _hoisted_25 = ["value"]
const _hoisted_26 = { class: "fv-plugins-message-container" }
const _hoisted_27 = { class: "fv-help-block" }
const _hoisted_28 = { class: "row mb-6" }
const _hoisted_29 = { class: "col-lg-4 col-form-label required fw-bold fs-6" }
const _hoisted_30 = { class: "col-lg-8 fv-row" }
const _hoisted_31 = { value: "" }
const _hoisted_32 = ["value"]
const _hoisted_33 = { class: "fv-plugins-message-container" }
const _hoisted_34 = { class: "fv-help-block" }
const _hoisted_35 = { class: "card-footer d-flex justify-content-end py-6 px-9" }
const _hoisted_36 = {
  type: "submit",
  ref: "submitButton",
  class: "btn btn-primary"
}
const _hoisted_37 = { class: "indicator-label" }
const _hoisted_38 = { class: "indicator-progress" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("span", { class: "spinner-border spinner-border-sm align-middle ms-2" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Form = _resolveComponent("Form")!

  return (_ctx.can('create', 'settings'))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("h3", _hoisted_4, _toDisplayString(_ctx.translate('Create New Package Discount')), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_Form, {
            class: "form",
            onSubmit: _ctx.onSubmitCreate,
            "validation-schema": _ctx.validationSchema
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _createElementVNode("label", _hoisted_8, _toDisplayString(_ctx.translate('Discount Amount')), 1),
                  _createElementVNode("div", _hoisted_9, [
                    _createVNode(_component_Field, {
                      type: "number",
                      name: "discountAmount",
                      min: "0",
                      max: "100",
                      class: "form-control form-control-lg form-control-solid",
                      placeholder: _ctx.translate('Enter Discount Amount')
                    }, null, 8, ["placeholder"]),
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("div", _hoisted_11, [
                        _createVNode(_component_ErrorMessage, { name: "discountAmount" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_12, [
                  _createElementVNode("label", _hoisted_13, _toDisplayString(_ctx.translate('Number of Lessons')), 1),
                  _createElementVNode("div", _hoisted_14, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "numberOfLessons",
                      class: "form-select form-select-lg form-select-solid"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", _hoisted_15, _toDisplayString(_ctx.translate('Select Number of Lessons')), 1),
                        _hoisted_16,
                        _hoisted_17,
                        _hoisted_18
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_19, [
                      _createElementVNode("div", _hoisted_20, [
                        _createVNode(_component_ErrorMessage, { name: "numberOfLessons" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_21, [
                  _createElementVNode("label", _hoisted_22, _toDisplayString(_ctx.translate('Package Type Id')), 1),
                  _createElementVNode("div", _hoisted_23, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "packageTypeId",
                      class: "form-select form-select-lg form-select-solid"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", _hoisted_24, _toDisplayString(_ctx.translate('Package Type')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.packageTypeList, (type) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: type.id,
                            value: type.id
                          }, _toDisplayString(type.nameEn), 9, _hoisted_25))
                        }), 128))
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_26, [
                      _createElementVNode("div", _hoisted_27, [
                        _createVNode(_component_ErrorMessage, { name: "packageTypeId" })
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_28, [
                  _createElementVNode("label", _hoisted_29, _toDisplayString(_ctx.translate('Class Category')), 1),
                  _createElementVNode("div", _hoisted_30, [
                    _createVNode(_component_Field, {
                      as: "select",
                      name: "classCategoryId",
                      class: "form-select form-select-lg form-select-solid"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("option", _hoisted_31, _toDisplayString(_ctx.translate('Class Category')), 1),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.classCategoryList, (category) => {
                          return (_openBlock(), _createElementBlock("option", {
                            key: category.id,
                            value: category.id
                          }, _toDisplayString(category.nameEn), 9, _hoisted_32))
                        }), 128))
                      ]),
                      _: 1
                    }),
                    _createElementVNode("div", _hoisted_33, [
                      _createElementVNode("div", _hoisted_34, [
                        _createVNode(_component_ErrorMessage, { name: "classCategoryId" })
                      ])
                    ])
                  ])
                ])
              ]),
              _createElementVNode("div", _hoisted_35, [
                _createElementVNode("button", {
                  type: "reset",
                  class: "btn btn-white btn-active-light-primary me-2",
                  onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args)))
                }, _toDisplayString(_ctx.translate('discard')), 1),
                _createElementVNode("button", _hoisted_36, [
                  _createElementVNode("span", _hoisted_37, _toDisplayString(_ctx.translate('saveChanges')), 1),
                  _createElementVNode("span", _hoisted_38, [
                    _createTextVNode(_toDisplayString(_ctx.translate('pleaseWait')) + " ", 1),
                    _hoisted_39
                  ])
                ], 512)
              ])
            ]),
            _: 1
          }, 8, ["onSubmit", "validation-schema"])
        ])
      ]))
    : _createCommentVNode("", true)
}